import { render, staticRenderFns } from "./AutoplugDeliveryWarning.vue?vue&type=template&id=539ed105&"
import script from "./AutoplugDeliveryWarning.vue?vue&type=script&lang=js&"
export * from "./AutoplugDeliveryWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports